import { Col, Row } from 'antd';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LoadingModal from 'components/generalUI/LoadingModal';
import GrillDetails from 'components/Grills/GrillDetails';
import Activities from 'components/sharedComponents/Activities';
import Header from 'components/sharedComponents/Header';
import { grillsBackground } from 'assets/media/misc';
import useListActivitiesWithoutTimes from 'apollo/resolvers/activities/listWithoutTimes';
import getNow from 'utils/dates/getNow';
import styles from './Grills.module.scss';

const Grills: FC = () => {
  const { t } = useTranslation();

  const [now] = useState(getNow());

  const { data: grills, loading } = useListActivitiesWithoutTimes(now, '2');

  return (
    <div className={styles.Container}>
      <Header
        title={t('pages.grills.title')}
        image={grillsBackground}
        letter="A"
        description={t('pages.grills.description')}
      />
      <LoadingModal visible={loading} />
      <GrillDetails grills={grills ? grills.listActivities : []} />
      <Row justify="center">
        <Col xs={20} sm={15} lg={10}>
          <h2 className={styles.Description}>{t('pages.grills.vacancyReminder')}</h2>
        </Col>
      </Row>
      <Row justify="center">
        <Col xs={20} sm={15} lg={10}>
          <ul className={styles.List}>
            <li>{t('pages.grills.grillValueText')}</li>
            <li>{t('pages.grills.garbageReminder')}</li>
            <li>{t('pages.grills.fireOnGrill')}</li>
            <li>{t('pages.grills.extras')}</li>
          </ul>
        </Col>
      </Row>
      <Activities />
    </div>
  );
};

export default Grills;
